import { SessionEventsAPI } from "../infrastructure/api/sessionEvents.api";

/**
 * Put the agenda's WhatsApp button on the session's timeline.
 *
 * Fire and forget: the chat opens whether or not this lands, and a
 * therapist is never told that a note on the timeline failed.
 */
export function recordManualWhatsAppReminder(sessionId: string): void {
    SessionEventsAPI.recordManualWhatsApp(sessionId).catch(() => undefined);
}
